import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import {
  LayoutDashboard,
  User,
  Image,
  Package,
  ShoppingCart,
  MessageCircle,
  DollarSign,
  Star,
  FileText,
} from "lucide-react";

interface VendorGraphicsSidebarProps {
  isOpen: boolean;
}

const VendorGraphicsSidebar: React.FC<VendorGraphicsSidebarProps> = ({ isOpen }) => {
  const location = useLocation();

  const menuItems = [
    {
      title: "Dashboard",
      href: "/vendor-graphics-dashboard",
      icon: LayoutDashboard,
    },
    {
      title: "Profile",
      href: "/vendor-graphics-dashboard/profile",
      icon: User,
    },
    {
      title: "Portfolio",
      href: "/vendor-graphics-dashboard/portfolio",
      icon: Image,
    },
    {
      title: "Packages",
      href: "/vendor-graphics-dashboard/packages",
      icon: Package,
    },
    {
      title: "Orders",
      href: "/vendor-graphics-dashboard/orders",
      icon: ShoppingCart,
    },
    {
      title: "Messages",
      href: "/vendor-graphics-dashboard/messages",
      icon: MessageCircle,
    },
    {
      title: "Reviews",
      href: "/vendor-graphics-dashboard/reviews",
      icon: Star,
    },
    {
      title: "Finance",
      href: "/vendor-graphics-dashboard/finance",
      icon: DollarSign,
    },
    {
      title: "W-9 Form",
      href: "/vendor-graphics-dashboard/w9",
      icon: FileText,
    },
  ];

  const isActive = (path: string) => {
    if (path === '/vendor-graphics-dashboard') {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <aside
      className={cn(
        "bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 transition-all duration-300",
        isOpen ? "w-64" : "w-16"
      )}
    >
      <div className="p-4">
        <div className="mb-6">
          {isOpen && (
            <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
              Graphics Vendor
            </h2>
          )}
        </div>

        <nav className="space-y-2">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.href}
                to={item.href}
                className={cn(
                  "flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors",
                  isActive(item.href)
                    ? "bg-primary text-primary-foreground"
                    : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700",
                  !isOpen && "justify-center"
                )}
              >
                <Icon className="h-5 w-5" />
                {isOpen && <span className="ml-3">{item.title}</span>}
              </NavLink>
            );
          })}
        </nav>
      </div>
    </aside>
  );
};

export default VendorGraphicsSidebar;